import React from 'react'
import { Checkbox, Select } from 'antd';
import { useSelector } from 'react-redux';
import Styles from "./ExpertRecordsStyles.module.css";


export default function TimeframeFilters({ state, onChangeFunc }) {
 const expertRecordsState = useSelector(state => state.expertRecord);
 const [minDate, setMinDate] = React.useState(state.curatedFromDate)
 const maxDate = () => {
   let newDate = new Date();
   return newDate.toISOString().split("T")[0];
 };
 return (
   <div style={{ textAlign: 'center', width: '100%' }}>
     <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
       <span style={{ width: '50%', marginRight: '15px', textAlign: 'end' }}><span style={{
         fontSize: "14px",
         color: "#2A364A", fontWeight: '300'
       }}>Exclude Email Questions&nbsp;</span></span>
       <span className='py-1'><Checkbox onChange={(e) => onChangeFunc(e.target.checked, 'email')} checked={state.excludeEmail} /></span>
     </div>
     <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
       <span style={{ width: '50%', marginRight: '15px', textAlign: 'end' }}><span style={{
         fontSize: "14px",
         color: "#2A364A", fontWeight: '300'
       }}>Urgent&nbsp;</span></span>
       <span className='py-1'><Checkbox onChange={(e) => onChangeFunc(e.target.checked, 'express')} checked={state.express} /></span>
     </div>
     <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
       <span style={{ width: '50%', marginRight: '15px', textAlign: 'end' }}><span style={{
         fontSize: "14px",
         color: "#2A364A", fontWeight: '300'
       }}>Last Updated&nbsp;</span></span>
       <span className='py-1'><Checkbox onChange={(e) => onChangeFunc(e.target.checked, 'isLast')} checked={state.isLastUpdate} /></span>
     </div>
     {state.isLastUpdate && <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
       <span style={{ width: '50%', marginRight: '15px', textAlign: 'end' }}><span style={{
         fontSize: "14px",
         color: "#2A364A", fontWeight: '300'
       }}>From Date&nbsp;</span></span>
       <span className='py-1'><input max={maxDate()} onChange={(e) => {
         onChangeFunc(e.target.value, 'from');
         setMinDate(e.target.value);
       }} value={state.curatedFromDate} className={Styles.inputFilterTab} type="date" /></span>
     </div>}
     {state.isLastUpdate && <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
       <span style={{ width: '50%', marginRight: '15px', textAlign: 'end' }}><span style={{
         fontSize: "14px",
         color: "#2A364A", fontWeight: '300'
       }}>To Date&nbsp;</span></span>
       <span className='py-1'><input min={minDate} max={maxDate()} onChange={(e) => onChangeFunc(e.target.value, 'to')} value={state.curatedToDate} className={Styles.inputFilterTab} type="date" /></span>
     </div>}
     {state.isLastUpdate && <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
       <span style={{ width: '50%', marginRight: '15px', textAlign: 'end' }}><span style={{
         fontSize: "14px",
         color: "#2A364A", fontWeight: '300'
       }}>Last Updated by&nbsp;</span></span>
       <span className='py-1' style={{ with: '36%' }}  >
         <Select style={{width:"100%"}} onChange={(e) => onChangeFunc(e, 'lastBy')}
           popupClassName={Styles.searchSuggestionCss} value={state.lastUpdateBy}
           options={expertRecordsState.expertsList} 
           
           showSearch
           filterOption={(input, option) =>
             (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
           }
           placeholder="Select Expert" size='middle' />
         {/* <Select
             labelInValue
             options={filterStatusOptions}
             value={state.status}
             // defaultValue={{ label: 'All', value: null }}
             onChange={onChangeStatus}
             placeholder="Select Status"
             popupClassName={Styles.searchSuggestionCss}
             size="middle"
             style={{ width: "100%", border: 'none', boxShadow: '0px 1px 2px 0px #1018280D', fontSize: '16px' }}
           /> */}


       </span>
     </div>}
   </div>
 )
}
